import React, { Fragment, useState } from "react";
import { Container, Grid, Header, Icon } from "semantic-ui-react";
import Base from "../Core/Base";
import { Animated } from "react-animated-css";
import About from "./About";
import Projects from "./Projects";
import Typist from "react-typist";
import QuickLink from "../components/QuickLinks";
import QueryAnswers from "../components/QueryAnswers";
import ButtonAwesome from "../Core/ButtonAwesome";

/**
 * @author
 * @function Home
 **/

const Home = props => {
  const [visible, setVisible] = useState(true);
  const [page, setPage] = useState("Home");
  const [value, setValue] = useState("about");

  let menus = [
    { name: "About", color: "#A77B06" },
    { name: "Projects", color: "#E8BD0D" },
    { name: "Quick Links", color: "#E5D68A" },
  ];

  // useEffect(() => {
  //   RenderMenu();
  // },[visible,page]);
  const HandleClick = value => {
    setVisible(false);
    setTimeout(() => {
      setPage(value);
    }, 200 * menus.length + 1);
  };

  const settingHistory = () => {
    setPage("Home");
    setValue("about")
    setVisible(true);
  };

  let MyViews = (
    <>
      <Container>
        <p>
          I passionately combine good design, technology, and innovation in all
          my projects, which I like to accompany from the first idea to release.
          Currently, I'm focused on the development of responsive user
          interfaces with React and I'm interested in JavaScript, Web
          Technologies, User Experience, Accessibility, Clean Code, and the
          Universe. And everything in between.
        </p>
      </Container>
    </>
  );

  const onButtonClick = (item) => {
    setValue(item);
    setPage("Query")
  }
  const menusReel = <>
  {menus.map((menu, index) => {
          return (
            <>
              <Animated
                animationIn="fadeInUp"
                animationOut="fadeOutUp"
                animationOutDelay={200 * index}
                animationInDelay={200 * index}
                isVisible={visible}
              >
                <Header
                  key={index}
                  onClick={() => HandleClick(menu.name)}
                  style={{
                    width: "100%",
                    borderBottom: "1px solid black",
                    padding: "25px",
                    background: menu.color,
                    color: "#FFFFFF"
                  }}
                >
                  <Icon name="arrow right" style={{ float: "right" }}></Icon>
                  {menu.name}
                </Header>
              </Animated>
            </>
          );
        })}
        <Header textAlign="center">
          <Typist>
            <span>Full Stack Developer</span>
            <Typist.Backspace count={20} delay={1000} />
            <span>Machine Learning enthusiast</span>
            <Typist.Backspace count={27} delay={2000} />
            <span>The Dev</span>
            <Typist.Backspace count={7} delay={2000} />
            <span>Problem solver</span>
            <Typist.Backspace count={14} delay={2000} />
            <span>Gamer</span>
            <Typist.Backspace count={5} delay={2000} />
            <span>And</span>
            <Typist.Backspace count={3} delay={1000} />
            <span style ={{color : "gold"}}>An Engineer</span>
          </Typist>
        </Header>
        {MyViews}
        <p style = {{textAlign : "center"}}><ButtonAwesome onQueryButtonClicked={onButtonClick}/></p></>
  const RenderMenu = () => {
    switch(value){
      case "about":
        return menusReel
      case "query":
        return <QueryAnswers value={value}/>
      default:
        return menusReel
    }
  };
  const SwitchPages = () => {
    switch (page) {
      case "Home":
        return RenderMenu();
      case "About":
        return <About setValue= {setValue} value ={value}/>;
      case "Projects":
        return <Projects history={props.history} />;
      case "Quick Links" :
        return <QuickLink/>
      default:
        return RenderMenu();
    }
  };
  
  if (window.innerWidth > 800) {
    return (
      <Fragment>
        <Container fluid>
          <Base title="Overview">
            {/* {RenderMenu()} */}
            <Grid columns={3} stackable>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Container style ={{textAlign : "center", alignItems : "center"}}>
                  <QuickLink />
                  </Container>
                </Grid.Column>
                <Grid.Column width={9}>
                  <Container>
                  <About setValue= {setValue} value ={value}/>
                  </Container>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Container style ={{paddingRight : "20px"}}>
                  <Projects />
                  </Container>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Base>
        </Container>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Base
        title={page}
        visibleProp={visible}
        hostortBackType={() => settingHistory()}
      >
        {/* <Header>HOME PAGE</Header> */}
        {SwitchPages()}
      </Base>
    </Fragment>
  );
};

export default Home;
